<template>
	<div class="pro-list" id="productList">
		<div class="pro-item wow fadeInUp" v-for="(item,index) in data" :key="index" data-wow-duration="1.3s" data-wow-delay="0.3s">
			<a :href="'/product?id=' + item.id" >
				<div class="pro-img" :class="{'intro-card-image-right___1L_iC': index%2!=0}">
					<img :src="item.img" />
				</div>
				<div class="intro-card-text___2HNrP " :class="{'intro-card-text-left___17FKG': index%2==0}">
					<div class="intro-card-text-content">
						<h1>{{item.title}}</h1>
						<div class="intro-card-text-content-intro___2w79Q">
							<p v-for="(txt,ind) in item.contents" :key="ind">{{txt}}</p>
						</div>
						<a :href="'/product?id=' + item.id" class="intro-card-text-content-more">
							<span class="more-text">查看更多</span>
							<i class="el-icon-arrow-right"></i>
						</a>
					</div>
					
				</div>
			</a>
		</div>
	</div>
</template>

<script>
	export default{
		props:['data'],
		data(){
			return{
				visible:false,
				nowIndex:-1
			}
		},
		mounted() {
			
		},
		methods:{
			
		}
	}
</script>

<style scoped>
	a{
		text-decoration: none;
	}
	.pro-list{
		
	}
	.pro-item{
		position: relative;
		max-width: 1200px;
		margin-top: 0;
		margin-bottom: 130px;
		/* opacity: 0; */
		/* animation-duration: .6s;
		animation-play-state: paused;
		animation-timing-function: cubic-bezier(.23,1,.75,1);
		animation-fill-mode: both; */
	}
	.pro-item.visible___3Z4Hr {
	  animation-name: fadeIn___2Wu-r;
	  animation-play-state: running;
	}
	.hidden___1e7hA {
	  visibility: hidden;
	}
	@keyframes fadeIn___2Wu-r {
	 0% {
	  top:80px;
	  opacity:0
	 }
	 to {
	  top:0;
	  opacity:1
	 }
	}
	.pro-item a{
		
	}
	.pro-item .pro-img{
		position: absolute;
		bottom: 48px;
		width: 46.6%;
		height: 440px;
		border-radius: 20px;
		overflow: hidden;
	}
	.pro-item .pro-img img{
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
	.intro-card-image-right___1L_iC{  
		right: 0;
	}
	.intro-card-text___2HNrP{
		max-width: 1072px;
		height: 440px;
		margin: 0 64px 0 0;
		padding: 56px 0 48px 64px;
		background-color: #f7f8fa;
		border-radius: 20px;
	}
	.intro-card-text-left___17FKG{
		display: flex;
		-ms-flex-pack: end;
		justify-content: flex-end;
		margin: 0 0 0 64px;
		padding: 56px 48px 48px 0;
	}
	.intro-card-text-content{
		display: flex;
		-ms-flex-direction: column;
		flex-direction: column;
		width: 50%;
		height: 336px;
		padding: 0 0 0 60px;
	}
	.pro-item:nth-child(2n) .intro-card-text-content{
		padding: 0;
	}
	.pro-item:last-child{
		margin-bottom: 0;
	}
	.intro-card-text-content h1{
		color: #333;
		font-weight: 600;
		font-size: 32px;
		font-family: AlibabaPuHuiTiRegular;
		line-height: 28px;
		margin-bottom: 20px;
		position: relative;
		font-weight: normal;
	}
	.intro-card-text-content h1::before{
		width: 110px;
		height: 6px;
		display: block;
		position: absolute;
		background: rgba(232, 146, 20, .8);
		content: '';
		bottom: -5px;
		left: 0;
	}
	
	.intro-card-text-content-intro___2w79Q{
		max-height: 205px;
		overflow: auto;
	}
	.intro-card-text-content-intro___2w79Q p{
		position: relative;
		padding-left: 24px;
		line-height: 40px;
		
		font-size: 18px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #666666;
		margin-bottom: 0;
	}
	.intro-card-text-content-intro___2w79Q p::before{
		position: absolute;
		content: '';
		left: 0;
		top: 13px;
		width: 14px;
		height: 14px;
		background: #FFE7C3;
		border-radius: 4px;
		
	}
	
	.intro-card-text-content-more{
		width: 128px;
		height: 48px;
		/* background: linear-gradient(90deg, #CC1E20, #E78B21, #E89214, #FCBC5D); */
		background-image: linear-gradient(90deg,#E89214,#FCBC5D);
		border-radius: 6px;
		text-align: center;
		line-height: 48px;
		
		display: -ms-flexbox;
		display: flex;
		-ms-flex-align: center;
		align-items: center;
		-ms-flex-pack: center;
		justify-content: center;
		width: 128px;
		height: 48px;
		margin: auto 0 0;
		color: #fff;
		border-radius: 4px;
	}
	.intro-card-text-content-more .more-text{
		font-size: 18px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #FFFFFF;
	}
	.intro-card-text-content-more i{
		margin-left: 7px;
		color: #fff;
		font-size: 18px;
		transition: all .45s cubic-bezier(.165,.84,.44,1);
	}
	.intro-card-text-content-more:hover i{
		transform:translateX(50%);
	}
</style>
<style scoped>
	@media only screen and (min-width:992px) and (max-width:1199px) {
		.pro-item{
			width: 992px;
			margin: 0 auto;
			margin-bottom: 120px;
		}
		.intro-card-text___2HNrP{
			width: 952px;
		}
		.pro-item .pro-img{
			width: 46.7%;
			text-align: center;
			border-radius: 20px;
		}
		.intro-card-text-left___17FKG{
			margin: 0 auto;
		}
		
	}
	@media only screen and (min-width:768px) and (max-width:991px) {
		.pro-item{
			width: 768px;
			margin: 0 auto;
			margin-bottom: 100px;
		}
		.pro-item .pro-img{
			width: 46.7%;
			text-align: center;
			border-radius: 20px;
		}
		.intro-card-text-left___17FKG{
			margin: 0 auto;
			padding: 46px 48px 38px 0;
		}
		.intro-card-text-content-intro___2w79Q{
			max-height: 233px;
		}
	}
	@media (max-width:767px) {
		
		.pro-item{
			width: 92%;/* calc(100% - 30px); */
			margin: 0 auto;
			margin-bottom: 30px;
			border-radius: 	10px;
			background-color: #f7f8fa;
			overflow: hidden;
		}
		.pro-list .pro-item:nth-child(4){
			margin-bottom: 0;
		}
		.pro-item .pro-img{
			position: relative;
			width:  100%;
			height: 190px;
			text-align: center;
			top: 0;
			border-radius: 0;
		}
		.intro-card-text___2HNrP{
			width: 100%;
			height: 265px;
			padding: 20px 20px;
			margin: 0;
		}
		.intro-card-text-left___17FKG{
			margin: 0;
			padding: 20px 20px;
		}
		.intro-card-text-content{
			width: 100%;
			height: 225px;
			padding: 0px;
		}
		.intro-card-text-content h1{
			font-size: 20px;
			margin-bottom: 12px;
		}
		.intro-card-text-content-intro___2w79Q{
			max-height: 180px;
		}
		.intro-card-text-content-intro___2w79Q p{
			font-size: 14px;
			margin-bottom: 5px;
			line-height: 25px;
		}
		.intro-card-text-content-intro___2w79Q p:before{
			top: 5px;
		}
		.intro-card-text-content-more{
			width: 88px;
			height: 28px;
			text-align: center;
			line-height: 28px;
		}
		.intro-card-text-content-more .more-text{
			font-size: 12px;
			
		}
	}
	
</style>